<template>
  <FormationDetailLayout
    lesson="Formation passerelle taxi vers vtc"
    back-item="carte-pro-vtc-taxi"
    :hero-image="heroImage"
    hero-alt="inside-car-man-driving"
    hero-eyebrow="Passerelle carte professionnelle"
    hero-title="PASSERELLE<br />taxi vers vtc"
    :hero-stats="heroStats"
  >
    <template #main>
      <article class="formation-section formation-section--intro">
        <h2>Transition Taxi vers VTC</h2>

        <div class="formation-flow">
          <p>
            Notre <strong>formation passerelle taxi vers VTC</strong> vous offre
            une <strong>transition</strong> fluide et efficace pour élargir vos
            opportunités professionnelles. Avec cette formation spécialisée,
            vous pourrez faire évoluer votre carrière en
            <strong
              >passant du métier de chauffeur de taxi à celui de chauffeur
              VTC</strong
            >. Nous vous proposons un programme complet qui vous permettra
            d'acquérir les compétences et les connaissances nécessaires pour
            réussir dans votre nouvelle activité.
          </p>

          <p>
            Avec une durée de 5 jours de formation intensive, notre programme
            vous permettra de maîtriser les aspects spécifiques du
            <strong>métier de chauffeur VTC</strong>. Vous apprendrez les règles
            et les réglementations propres à l'<strong>activité VTC</strong>,
            les techniques de relation client, la gestion des réservations et
            des itinéraires, ainsi que les bonnes pratiques commerciales pour
            développer votre activité.
          </p>

          <p>
            Notre <strong>formation passerelle taxi vers VTC</strong> est
            disponible à convenir selon vos disponibilités. Nous nous efforçons
            de vous offrir des horaires flexibles afin de répondre à vos besoins
            et à votre emploi du temps. Vous pourrez ainsi suivre la
            <strong>formation</strong> sans perturber vos activités
            professionnelles actuelles.
          </p>

          <p>
            Pendant la <strong>formation</strong>, un véhicule vous sera mis à
            disposition pour les exercices pratiques et les mises en situation.
            Vous pourrez ainsi vous familiariser avec les caractéristiques
            spécifiques des véhicules utilisés dans l'<strong
              >activité VTC</strong
            >
            et vous entraîner dans des conditions réalistes.
          </p>

          <p>
            Une fois la formation terminée, vous serez prêt à passer l'<strong
              >examen de conversion taxi vers VTC</strong
            >. Nous vous accompagnerons tout au long du processus et vous
            fournirons les informations nécessaires pour vous préparer
            efficacement. Notre objectif est de vous donner toutes les clés pour
            réussir dans votre nouvelle
            <strong>carrière en tant que chauffeur VTC</strong>.
          </p>

          <p>
            N'hésitez pas à vous inscrire à notre
            <strong>formation passerelle taxi vers VTC</strong> et à saisir
            cette opportunité de développer votre activité professionnelle. Avec
            nos connaissances et notre soutien, vous serez prêt à faire le grand
            saut vers une nouvelle étape passionnante de votre carrière.
          </p>
        </div>
      </article>

      <ExamPrerequisitesCard mode="mix" />
    </template>
  </FormationDetailLayout>
</template>

<script>
import ExamPrerequisitesCard from "@/components/formations/ExamPrerequisitesCard.vue";
import FormationDetailLayout from "@/components/formations/FormationDetailLayout.vue";
import { useMeta } from "vue-meta";

const heroImage = require("@/assets/pictures/passerelle-taxi-vtc.webp");
const heroStats = [
  { label: "Prix", value: "600€" },
  { label: "Durée", value: "5 jours / disponibilités à convenir" },
  { label: "Voiture de prêt", value: "pour l'examen" },
];

export default {
  name: "PasserelleTaxiVtc",
  components: { ExamPrerequisitesCard, FormationDetailLayout },
  setup() {
    useMeta({
      title: "Passez de Taxi à VTC",
      description: [
        {
          content:
            "Optimisez votre carrière en passant de taxi à VTC avec la Formation Passerelle de Taxi vers VTC. Développez de nouvelles compétences et profitez de nouvelles opportunités dans le domaine du transport de personnes. Rejoignez notre programme de formation dès aujourd'hui !",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-mobilite-passerelle-taxi-vers-vtc",
        },
      ],
    });
  },
  data() {
    return {
      heroImage,
      heroStats,
    };
  },
};
</script>
